export default function Double_Click_to_Fill() {
  return <div>Double_Click_to_Fill</div>;
}
